import React, { memo } from 'react';
import { buildMutationRows, mutationTypes } from './mutationUtils';
import { Card, CardContent, CardHeader, List, ListItem } from '@mui/material';
import BtnOpenMutation from './BtnOpenMutation';

const MutationTable = ({ title, word, rowHeaders }) => {

  const { rows, hasMutations } = buildMutationRows(rowHeaders, word);

  return (
    <Card>
      <CardContent>
        <CardHeader
          title={`${title} (${word.sourceContent})`}
          action={
            <>
              {hasMutations.spirante && <BtnOpenMutation mutationType={mutationTypes.SPIRANTE} />}
              {hasMutations.hard && <BtnOpenMutation mutationType={mutationTypes.HARD} />}
              {hasMutations.mixed && <BtnOpenMutation mutationType={mutationTypes.MIXED} />}
              {hasMutations.soft && <BtnOpenMutation mutationType={mutationTypes.SOFT} />}
            </>
          } />

        <List className={'mutation-table'}>
          {rows.map((row, idx) => (
            <ListItem key={idx} className={`${row.rowHeader.mutationType} ${row.hasMutated ? 'mutation-bg' : ''}`}>
              <span><em>{row.label}</em> {row.result}</span>
            </ListItem>
          ))}
        </List>

      </CardContent>
    </Card>
  );
};

export default memo(MutationTable);
